module.exports = __webpack_public_path__ + "static/ri-551e2b7f5aa0a81c7c8c94d7311090c9.png";